module.exports = __webpack_public_path__ + "static/estadio-fdafadb2329f7de85962842c36f7728a.jpg";